import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, EffectFade } from 'swiper/modules';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

const slides = [
  {
    img: '/images/banner/banner1-1.jpg',
    sub: 'Welcome to Manchester Villa Hotel',
    title: 'Premium Hospitality\nin the Heart of Owerri',
    desc: 'Plot 34, Area T, behind Apams Casket off PH Road, Owerri',
    btn1: { label: 'Book a Room', to: '/rooms' },
    btn2: { label: 'View Facilities', to: '/services' },
  },
  {
    img: '/images/banner/banner1-2.jpg',
    sub: 'Luxury Meets Comfort',
    title: 'Rooms From ₦30,000\nPer Night',
    desc: 'China • Canada • United Kingdom • USA room tiers available',
    btn1: { label: 'See Room Rates', to: '/rooms' },
    btn2: { label: 'Contact Us', to: '/contact' },
  },
  {
    img: '/images/banner/banner1-3.jpg',
    sub: 'Dine, Relax & Unwind',
    title: 'Restaurant, Bar &\nGames Lounge On-Site',
    desc: 'Authentic Nigerian cuisine, premium spirits & pool table awaits you',
    btn1: { label: 'Explore Dining', to: '/pricing' },
    btn2: { label: 'About Us', to: '/about' },
  },
];

export default function BannerSection() {
  return (
    <section className="banner-section">
      <Swiper modules={[Autoplay, Navigation, EffectFade]} effect="fade"
        autoplay={{ delay: 5000, disableOnInteraction: false }} navigation loop speed={900}
        className="banner-swiper">
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div className="banner-slide">
              <div className="banner-bg" style={{ backgroundImage: `url(${slide.img})` }} />
              <div className="banner-overlay" />
              <div className="banner-content">
                <div className="auto-container">
                  <span className="banner-sub wow fadeInDown">{slide.sub}</span>
                  <h1 className="banner-title wow fadeInUp" data-wow-delay="200ms">
                    {slide.title.split('\n').map((line, j, arr) => (
                      <React.Fragment key={j}>{line}{j < arr.length - 1 && <br />}</React.Fragment>
                    ))}
                  </h1>
                  <p className="banner-desc wow fadeInUp" data-wow-delay="300ms">{slide.desc}</p>
                  <div className="banner-stars wow fadeInUp" data-wow-delay="350ms">
                    {[...Array(5)].map((_, k) => <i key={k} className="fas fa-star"></i>)}
                    <span>Top-Rated Hotel in Owerri</span>
                  </div>
                  <div className="banner-btns wow fadeInUp" data-wow-delay="400ms">
                    <Link to={slide.btn1.to} className="banner-btn primary">{slide.btn1.label}</Link>
                    <Link to={slide.btn2.to} className="banner-btn secondary">{slide.btn2.label}</Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
